import { type ButlerItem, type ProductMap } from '@cart-services/types'

// 辨識結果一進來就預設勾選；商品資訊載入前卡片仍顯示辨識中，也查不到配送方式，送出、檢查與計數都只能看已載入的列
export const getSubmittableButlerItems = (items: ButlerItem[], productMap: ProductMap | undefined): ButlerItem[] =>
  items.filter(item => item.checked && !item.isDeleted && !!item.variation_id && !!productMap?.[item.variation_id])
